import React from 'react'
import './rightSide.css'

const RightSide = () => {
  return (
    <div className='rightSideHome'>

      {/* TOP PROFILE */}
     <div className="topProfileRight">
        <div className='imageDivRightSide'>
          <img
            className='imageRightSideProfile'
            src='https://i.pinimg.com/736x/0a/87/01/0a870123e297d7f64fc5ad5741a5e69a.jpg'
            alt='profile'
          />
        </div>

        <div className='rightProfileInfo'>
          <h4>rapchik_music</h4>
          <span>Music Creator</span>
        </div>

        <div className='rightProfileBtn'>Switch</div>
      </div>

      {/* SUGGESTIONS */}
      <p className='suggestionTitle'>Suggestions For You</p>

      {[1, 2, 3, 4, 5,6].map((item, index) => (
        <div className='suggestionUser' key={index}>
          <img
            src='https://i.pinimg.com/736x/09/3d/2c/093d2cfc19371df937817930112f3db2.jpg'
            alt='user'
          />

          <div className='suggestionInfo'>
            <p>rap_user_{index + 1}</p>
            <span>New to Rapchik</span>
          </div>

          <span className='followBtn'>Follow</span>
        </div>
      ))}

      {/* FOOTER */}
      <div className='rightFooter'>
        About · Help · Press · API · Jobs <br />
        Privacy · Terms · Locations <br />
        © 2025 RAPCHIK
      </div>

    </div>
  )
}

export default RightSide
